/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/pt-BR'

import iconSet from 'quasar/icon-set/fontawesome-v5'



import {Loading,Notify,AppFullscreen,LocalStorage,Meta,Cookies,Dialog} from 'quasar'



export default { config: {"loading":{"delay":0},"capacitor":{"iosStatusBarPadding":true}},lang,iconSet,plugins: {Loading,Notify,AppFullscreen,LocalStorage,Meta,Cookies,Dialog} }

